/**
 * useUsers — fetches all active users (for owner dropdowns in modals,
 * org chart, name resolution, etc.).
 *
 * RLS already restricts this: any authenticated user can SELECT all
 * users, so this returns the whole company.
 */

import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../api/supabase.js';

export function useUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUsers = useCallback(async () => {
    setError(null);
    const { data, error: fetchError } = await supabase
      .from('users')
      .select('id, full_name, role, department, avatar_url, status')
      .eq('status', 'active')
      .order('full_name', { ascending: true });

    if (fetchError) {
      console.error('[ORIN] Failed to fetch users:', fetchError.message);
      setError(fetchError.message);
      setUsers([]);
    } else {
      setUsers(data || []);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return { users, loading, error, refresh: fetchUsers };
}